<template>
<div v-if="loading" class="container">
    <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Desktop_v1.svg" alt="">
    <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Desktop_v1.svg" alt="">
    <img class="hidden-md hidden-lg" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Desktop_v1.svg" alt="">
</div>
<div v-if='expert && !loading'>
    <div class="hidden-md hidden-xs hidden-sm" v-if="disturberHtml" v-html="disturberHtml">
    </div>
    <!-- <div class="gdlr-page-title-wrapper gdlr-parallax-wrapper gdlr-title-normal">
        <div class="gdlr-page-title-overlay vueHeader"></div>
        <div class="gdlr-page-title-container vueHeader" :class="container">
            <h1 v-if="expert.forename && expert.surname" class="gdlr-page-title sands-gdlr-page-title">{{expert.forename}} {{expert.surname}}</h1>
            <h1 v-else-if="expert.name" class="gdlr-page-title sands-gdlr-page-title">{{expert.name}}</h1>
        </div>
    </div> -->

    <div class='expert--detail'>
        <div class="with-sidebar-wrapper vueeee">
            <div class="with-sidebar-container sands-container  gdlr-class-no-sidebar">
                <div class="with-sidebar-left twelve columns">
                    <div class="with-sidebar-content twelve columns">
                        <div class="gdlr-item gdlr-item-start-content">
                            <!-- if no cookie and expert has active locations STart-->
                            <div v-if="activeLocationsOfThisExpert && activeLocationsOfThisExpert.length" class="to-the-current-program-page-block bg__grey mlc-location-independent-block-invisible global-border-radius bg__grey">
                                <span class="go-to-program-page language-dependent-block-invisible">This Speaker&nbsp;</span>
                                <span class="language-dependent-block-invisible-de go-to-program-page">Dieser&nbsp;Speaker&nbsp;</span>
                                <span class="language-dependent-block-invisible-de go-to-program-page"> gehört zum Programm von&nbsp;</span>
                                <span class="go-to-program-page language-dependent-block-invisible"> belongs to the &nbsp;</span>
                                <span v-for="(aLocation, index) in locationsCurrentTalksBelongsTo" :key="index" class="language-dependent-block-invisible go-to-program-page">{{aLocation.city}}<span v-if="index+1 != locationsCurrentTalksBelongsTo.length && locationsCurrentTalksBelongsTo.length > 2">,&nbsp;</span><span v-if="index+1 != locationsCurrentTalksBelongsTo.length && locationsCurrentTalksBelongsTo.length == 2">&nbsp;and&nbsp;</span> </span>

                                <span v-for="(aLocation, index) in locationsCurrentTalksBelongsTo" :key="index" class="language-dependent-block-invisible-de go-to-program-page">{{aLocation.city_de}}<span v-if="index+1 != locationsCurrentTalksBelongsTo.length && locationsCurrentTalksBelongsTo.length > 2">,&nbsp;</span><span v-if="index+1 != locationsCurrentTalksBelongsTo.length && locationsCurrentTalksBelongsTo.length == 2">&nbsp;und&nbsp;</span></span>
                                <span class="go-to-program-page language-dependent-block-invisible">&nbsp;program.&nbsp; </span>
                                <span class="go-to-program-page language-dependent-block-invisible">Take me to the current program of&nbsp;</span>
                                <span class="language-dependent-block-invisible-de go-to-program-page">. Hier geht es zum aktuellen Programm von&nbsp;</span>
                                <template v-for="(aLocation, index) in activeLocations" :key="index">
                                    <a v-if="aLocation.programbuttonLink && aLocation.location_color && aLocation.city" :href="aLocation.programbuttonLink" :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible go-to-program-page" :class="aLocation.identifier">{{aLocation.city}}
                                    </a>
                                    <a v-if="aLocation.programbuttonLink && aLocation.location_color && aLocation.city" :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink_DE"> &nbsp;{{aLocation.city_de}}</a>
                                    <span v-if="activeLocations.length && activeLocations.length > 1">
                                        <span v-if="index === activeLocations.length -  2">&nbsp;{{ $t('or') }}&nbsp;</span>
                                        <span v-else-if="index < activeLocations.length - 2 && index != activeLocations.length -  1">,&nbsp;</span>
                                    </span>
                                </template>
                                .
                            </div>
                            <!-- if no cookie and expert has no active for sessions locations STart-->
                            <div v-else-if="editionLabelTXDataForThisExpert && editionLabelTXDataForThisExpert.length" class="to-the-current-program-page-block bg__grey mlc-location-independent-block-invisible global-border-radius bg__grey">
                                <span v-if="locationBelongsToaCurrentOne(editionLabelTXDataForThisExpert)">
                                    <span class="go-to-program-page language-dependent-block-invisible">This Speaker&nbsp;</span>
                                    <span class="language-dependent-block-invisible-de go-to-program-page">Dieser&nbsp;Speaker&nbsp;</span>
                                    <span class="language-dependent-block-invisible go-to-program-page">originates from the archive of </span>
                                    <span class="language-dependent-block-invisible-de go-to-program-page"> stammt aus dem Archiv von&nbsp;</span>

                                    <span v-for="(aLocation, index) in locationBelongsToaCurrentOne(editionLabelTXDataForThisExpert)" :key="index" class="language-dependent-block-invisibl go-to-program-page">
                                        <span v-if="aLocation && aLocation.belongsTo">&nbsp;{{aLocation.belongsTo}}
                                            <span v-if="locationBelongsToaCurrentOne(editionLabelTXDataForThisExpert) && locationBelongsToaCurrentOne(editionLabelTXDataForThisExpert).length">
                                                <span v-if="index != locationBelongsToaCurrentOne(editionLabelTXDataForThisExpert).length -  2">,&nbsp;</span>
                                                <span v-if="index == locationBelongsToaCurrentOne(editionLabelTXDataForThisExpert).length -  2">{{ $t('or') }}&nbsp;</span>
                                            </span>
                                        </span>
                                    </span>&nbsp;
                                </span>
                                <span class="go-to-program-page language-dependent-block-invisible">Take me to the current program of&nbsp;</span>
                                <span class="language-dependent-block-invisible-de go-to-program-page">. Hier geht es zum aktuellen Programm von&nbsp;</span>
                                <a v-for="(aLocation, index) in activeLocations" :key="index" :href="aLocation.programbuttonLink" :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible go-to-program-page ">{{aLocation.city}} <span v-if="index < activeLocations.length -  2">,&nbsp;</span>
                                    <span v-if="index == activeLocations.length -  2">{{ $t('or') }}&nbsp;</span></a>
                                <a v-for="(aLocation, index) in activeLocations" :key="index" :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page hhh" :class="aLocation.identifier" :href="aLocation.programbuttonLink_DE"> &nbsp;{{aLocation.city_de}}
                                    <span v-if="index < activeLocations.length -  2">,&nbsp;</span>
                                    <span v-if="index == activeLocations.length -  2">{{ $t('or') }}&nbsp;</span></a>
                                .
                            </div>
                            <!-- expert has Active locations and active cookie -->
                            <div v-if="activeLocationsOfThisExpert && activeLocationsOfThisExpert.length && currentActiveLocation && currentActiveLocation && currentActiveLocation.identifier">

                                <div v-for="(aLocation, index) in activeLocationsOfThisExpert" :key="index">
                                    <div v-if="cookie && cookie !== 'all' && cookie != undefined && aLocation.identifier && currentActiveLocation.identifier == cookie" class="global-border-radius bg__grey to-the-current-program-page-block mlc-location-dependent-block-invisible" :class="aLocation.identifier">
                                        <div v-if="(talkToBeDisplayedOnTopInstanceIds.includes(aLocation.instanceID)) || (BackendTalksToBeDisplayedOnTop && BackendTalksToBeDisplayedOnTop.length && BackendTalksToBeDisplayedOnTop[0] && BackendTalksToBeDisplayedOnTop[0].locationIdentifier && BackendTalksToBeDisplayedOnTop[0].locationIdentifier.includes(aLocation.identifier))">
                                            <span class="language-dependent-block-invisible go-to-program-page">Take me to the full program of </span>
                                            <span class="language-dependent-block-invisible-de go-to-program-page">Zum vollst&auml;ndigen Programm von </span>
                                            <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink">&nbsp;{{aLocation.city}}</a>
                                            <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink_DE">&nbsp;{{aLocation.city_de}}</a>
                                        </div>
                                        <div v-else>
                                            <span class="language-dependent-block-invisible go-to-program-page">This Speaker belongs to the&nbsp;</span>
                                            <span class="language-dependent-block-invisible-de go-to-program-page">Dieser Speaker geh&ouml;rt zum Programm vom&nbsp; </span>
                                            <span v-if="locationsCurrentTalksBelongsTo && locationsCurrentTalksBelongsTo.length">
                                                <a v-for="(aRelatedLocation, index) in locationsCurrentTalksBelongsTo" :key="index" :href="aRelatedLocation.programbuttonLink" :style="{'color':aRelatedLocation.location_color}" class="language-dependent-block-invisible go-to-program-page ">{{aRelatedLocation.city}} <span v-if="index < locationsCurrentTalksBelongsTo.length -  2">,&nbsp;</span>
                                                    <span v-if="index == locationsCurrentTalksBelongsTo.length -  2">{{ $t('or') }}&nbsp;</span>
                                                </a>
                                                <a v-for="(aRelatedLocation, index) in locationsCurrentTalksBelongsTo" :key="index" :style="{'color':aRelatedLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page hhh" :class="aRelatedLocation.identifier" :href="aRelatedLocation.programbuttonLink_DE"> &nbsp;{{aRelatedLocation.city_de}}
                                                    <span v-if="index < locationsCurrentTalksBelongsTo.length -  2">,&nbsp;</span>
                                                    <span v-if="index == locationsCurrentTalksBelongsTo.length -  2">{{ $t('or') }}&nbsp;</span>
                                                </a>
                                            </span>
                                            <span class="language-dependent-block-invisible go-to-program-page">&nbsp;program. Take me to the program of </span>
                                            <span class="language-dependent-block-invisible-de go-to-program-page">. Hier geht es zum Programm von </span>
                                            <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink">&nbsp;{{aLocation.city}}</a>
                                            <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink_DE">&nbsp;{{aLocation.city_de}}</a>
                                        </div>

                                    </div>

                                    <div v-else-if="cookie && cookie !== 'all' && cookie != currentActiveLocation.identifier">
                                        <div class="to-the-current-program-page-block mlc-location-dependent-block-invisible bg__grey global-border-radius" :class="cookie">
                                            <span>{{ $t('this-speaker-belong') }}</span>
                                            <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink">&nbsp;{{aLocation.city}}</a>
                                            <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink_DE">&nbsp;{{aLocation.city_de}}</a>
                                            <span>&nbsp;{{ $t('program') }}.</span>
                                            <span v-if="currentActiveLocation">&nbsp;{{ $t('take-me-to-the') }}</span>
                                            <a :style="{'color':currentActiveLocation.location_color}" class="language-dependent-block-invisible go-to-program-page" :class="currentActiveLocation.identifier" :href="currentActiveLocation.programbuttonLink">&nbsp;{{currentActiveLocation.city}}</a>
                                            <a :style="{'color':currentActiveLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="currentActiveLocation.identifier" :href="currentActiveLocation.programbuttonLink_DE">&nbsp;{{currentActiveLocation.city_de}}</a>
                                            .
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- new speakerBio wrapper  start -->
                            <div class="d-flex p-5 ex__new__wrapper" style="gap: 50px;">
                                <div class="expert-image-eapper">
                                    <div class="gdlr-speaker-thumbnail">
                                        <div class="sands-image-colored-overlay-hover ">
                                            <img v-if="expert.image" :src="expert.image" width="500" height="333" :alt="expert.forename + ' ' + expert.surname">
                                            <span v-else-if="expert.wpImage" v-html="expert.wpImage"></span>
                                        </div>
                                    </div> 
                                    <div class="sands-speaker-info-inner gdlr-speaker-social gdlr-speaker-social-spleaker-detail old-layout">
                                        <a target="_blank" v-if="expert.facebook" class="gdlr-social-shortcode" :href="expert.facebook"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/facebook.png" alt="facebook-icon"></a>
                                        <a target="_blank" v-if="expert.twitter" class="gdlr-social-shortcode" :href="expert.twitter"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/twitter.png" alt="twitter-icon"></a>
                                        <a target="_blank" v-if="expert.google" class="gdlr-social-shortcode" :href="expert.google"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/googleplus.png" alt="googleplus-icon"></a>
                                        <a target="_blank" v-if="expert.linkedin" class="gdlr-social-shortcode" :href="expert.linkedin"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/linkedin.png" alt="linkedin-icon"></a>
                                        <a target="_blank" v-if="expert.blog" class="gdlr-social-shortcode" :href="expert.blog"><img src="/wp-content/themes/sands-events-subtheme/img/blog_Icon_v2.png" alt="blog-icon"></a>
                                    </div>   
                                </div>
                                <div class="expert-info-wrapper__bio" >
                                    <h1 v-if="expert.forename && expert.surname" class="gdlr-speaker-biography-title expert__title">{{expert.forename}} {{expert.surname}}</h1>
                                    <h2 v-if="expert && expert.company" class="gdlr-speaker-position">{{expert.company}}
                                    </h2>
                                    <div v-if="expert.bio" v-html="expert.bio" class="gdlr-speaker-content"></div>
                                </div>
                                
                            </div>
                            <!-- new speakerBio wrapper  ends -->


                            <div class="speaker type-speaker status-publish has-post-thumbnail hentry">
                                <div v-if="widgetHtml" class="gdlr-speaker-info-wrapper sands-gdlr-speaker-info-wrapper mt-5">

                                    <div v-if="widgetHtml" class="call-for-action-box old-layout">
                                        <span v-html="widgetHtml" class='global-border-radius'></span>
                                    </div>
                                </div>
                                <div class="gdlr-speaker-content-wrapper">
                                    <template v-if="activeLocations && activeLocations.length">
                                        <div v-for="(activeLocation, index) in activeLocations" :key="index">
                                            <div class="mlc-location-dependent-block-invisible my-5" :class="activeLocation.identifier">
                                                <div class="mb-5 px-4 py-5 top-sessions__wrapper_with_location global-border-radius">
                                                    <h3 v-if="expert.forename && expert.surname" class='h4 single-speaker gdlr-speaker-session-title'>All talks by {{expert.forename}} {{expert.surname}} </h3>
                                                    <h3 v-else-if="expert.name" class='single-speaker gdlr-speaker-session-title h4'>All talks by {{expert.name}} </h3>
                                                    <div v-if="talksToBeDisplayedOnTop && talksToBeDisplayedOnTop.length && talksToBeDisplayedOnTop.length > 0">
                                                        <div v-for="(aTalk, index) in filterTalkByLocation(talksToBeDisplayedOnTop,activeLocation.identifier)" :key="index">
                                                            <div v-if="aTalk.postPermalink">
                                                                <div v-for="(aTalkEdition, index) in aTalk.singleEditionLabels" :key="index">
                                                                    <div v-if="aTalkEdition">
                                                                        <div v-if="aTalkEditionIsInActiveSessions(aTalkEdition,activeLocationEditionLabel)">
                                                                            <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible-de speaker-edition-label-display speaker-session-view-location-tag '>
                                                                                {{getGermanEditionName(aTalkEdition)}}
                                                                            </span>
                                                                            <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible speaker-edition-label-display speaker-session-view-location-tag '>
                                                                                {{getEnglishEditionName(aTalkEdition)}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <a :href="'/'+ aTalk.postPermalink">
                                                                    <p style='display:inline;'>{{aTalk.title}}</p>
                                                                </a><br /><br />
                                                            </div>
                                                        </div>
                                                        <div v-if="filterTalkByLocation(talksToBeDisplayedOnTop,activeLocation.identifier).length == 0">
                                                            <div v-if="BackendTalksToBeDisplayedOnTop && BackendTalksToBeDisplayedOnTop.length">
                                                                <div v-for="(aTalk, index) in BackendTalksToBeDisplayedOnTop" :key="index">
                                                                    <div v-if="aTalk && aTalk.postPermalink">
                                                                        <div v-for="(aTalkEdition, index) in aTalk.singleEditionLabels" :key="index">
                                                                            <div v-if="aTalkEdition">
                                                                                <div v-if="aTalkEditionIsInActiveSessions(aTalkEdition,activeLocationEditionLabel)">
                                                                                    <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible-de speaker-edition-label-display speaker-session-view-location-tag '>
                                                                                        {{getGermanEditionName(aTalkEdition)}}
                                                                                    </span>
                                                                                    <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible speaker-edition-label-display speaker-session-view-location-tag '>
                                                                                        {{getEnglishEditionName(aTalkEdition)}}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <a :href="'/'+aTalk.postPermalink"  >
                                                                            <p style='display:inline;'>{{aTalk.title}}</p>
                                                                        </a><br /><br />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                {{ $t('no-current-talks-available') }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        {{ $t('no-current-talks-available') }}
                                                    </div>
                                                </div>
                                                <div class='bottom-talks py-5 px-4 global-border-radius' v-if="(talksToBeDisplayedOnBottom && talksToBeDisplayedOnBottom.length && talksToBeDisplayedOnBottom.length > 0) || (talksToBeDisplayedOnTop && talksToBeDisplayedOnTop.length && filterTalkByLocation(talksToBeDisplayedOnTop,activeLocation.identifier).length == 0)">
                                                    <h3 v-if="expert.forename && expert.surname" class='h4 single-speaker gdlr-speaker-session-title'>All talks by {{expert.forename}} {{expert.surname}} from other editions</h3>
                                                    <h3 v-else-if="expert.name" class='h4 single-speaker gdlr-speaker-session-title'>All talks by {{expert.name}} from other editions</h3>
                                                    <div>
                                                        <div class="BackendTalksToBeDisplayedOnTop" v-if="BackendTalksToBeDisplayedOnTop && BackendTalksToBeDisplayedOnTop.length">
                                                            <div v-for="(aTalk, index) in BackendTalksToBeDisplayedOnTop" :key="index">
                                                                <div v-if="aTalk && aTalk.postPermalink">
                                                                    <div v-for="(aTalkEdition, index) in aTalk.singleEditionLabels" :key="index">
                                                                        <div v-if="aTalkEdition">
                                                                            <div>
                                                                                <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible-de speaker-edition-label-display speaker-session-view-location-tag '>
                                                                                    {{getGermanEditionName(aTalkEdition)}}
                                                                                </span>
                                                                                <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible speaker-edition-label-display speaker-session-view-location-tag '>
                                                                                    {{getEnglishEditionName(aTalkEdition)}}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <a :href="'/'+aTalk.postPermalink">
                                                                        <p style='display:inline;'>{{aTalk.title}}</p>
                                                                    </a><br /><br />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-for="(aTalk, index) in talksToBeDisplayedOnBottom" :key="index">
                                                        <div v-if="aTalk && aTalk.postPermalink">
                                                            <div v-for="(aTalkEdition, index) in aTalk.singleEditionLabels" :key="index">
                                                                <div v-if="aTalkEdition">
                                                                    <div>
                                                                        <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible-de speaker-edition-label-display speaker-session-view-location-tag '>
                                                                            {{getGermanEditionName(aTalkEdition)}}
                                                                        </span>
                                                                        <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible speaker-edition-label-display speaker-session-view-location-tag '>
                                                                            {{getEnglishEditionName(aTalkEdition)}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <a :href="'/'+ aTalk.postPermalink">
                                                                <p style='display:inline;'>{{aTalk.title}}</p>
                                                            </a><br /><br />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </template>

                                    <div class="mlc-location-independent-block-invisible">
                                    <!-- top speaker sessions without cookie -->
                                        <div class='bg__grey global-border-radius px-4 py-4 my-5'>
                                            <h3 v-if="expert.forename && expert.surname" class='single-speaker gdlr-speaker-session-title h4'>All talks by {{expert.forename}} {{expert.surname}} </h3>
                                            <h3 v-else-if="expert.name" class='single-speaker gdlr-speaker-session-title h4'>All talks by {{expert.name}} </h3>
                                            <div v-if="talksToBeDisplayedOnTop && talksToBeDisplayedOnTop.length && talksToBeDisplayedOnTop.length > 0">
                                                <div v-for="(aTalk, index) in talksToBeDisplayedOnTop" :key="index">
                                                    <div v-if="aTalk && aTalk.postPermalink">
                                                        <div v-for="(aTalkEdition, index) in aTalk.singleEditionLabels" :key="index">
                                                            <div v-if="aTalkEdition">
                                                                <div v-if="aTalkEditionIsInActiveSessions(aTalkEdition,activeLocationEditionLabel,aTalk)">
                                                                    <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible-de speaker-edition-label-display speaker-session-view-location-tag '>
                                                                        {{getGermanEditionName(aTalkEdition)}}
                                                                    </span>
                                                                    <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible speaker-edition-label-display speaker-session-view-location-tag '>
                                                                        {{getEnglishEditionName(aTalkEdition)}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <a :href="'/'+aTalk.postPermalink">
                                                            <p style='display:inline;'>{{aTalk.title}}</p>
                                                        </a><br /><br />
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="BackendTalksToBeDisplayedOnTop && BackendTalksToBeDisplayedOnTop.length">
                                                <div v-for="(aTalk, index) in BackendTalksToBeDisplayedOnTop" :key="index">
                                                    <div v-if="aTalk && aTalk.postPermalink">
                                                        <div v-for="(aTalkEdition, index) in aTalk.singleEditionLabels" :key="index">
                                                            <div v-if="aTalkEdition">
                                                                <div v-if="aTalkEditionIsInActiveSessions(aTalkEdition,activeLocationEditionLabel)">
                                                                    <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible-de speaker-edition-label-display speaker-session-view-location-tag '>
                                                                        {{getGermanEditionName(aTalkEdition)}}
                                                                    </span>
                                                                    <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible speaker-edition-label-display speaker-session-view-location-tag '>
                                                                        {{getEnglishEditionName(aTalkEdition)}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <a :href="'/'+aTalk.postPermalink">
                                                            <p style='display:inline;'>{{aTalk.title}}</p>
                                                        </a><br /><br />
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="(!talksToBeDisplayedOnTop && !BackendTalksToBeDisplayedOnTop) || (!talksToBeDisplayedOnTop.length && !BackendTalksToBeDisplayedOnTop.length)">
                                                {{ $t('no-current-talks-available') }}
                                            </div>
                                        </div>
                                        <!-- top speaker sessions without cookie ends -->

                                        <!-- archive/old speaker sessions without cookie -->
                                        <div class='bg__grey global-border-radius px-4 py-4 my-5'>
                                            <div v-if="talksToBeDisplayedOnBottom && talksToBeDisplayedOnBottom.length && talksToBeDisplayedOnBottom.length > 0">
                                                <h3 v-if="expert.forename && expert.surname" class='single-speaker gdlr-speaker-session-title h4'>All talks by {{expert.forename}} {{expert.surname}} from other editions</h3>
                                                <h3 v-else-if="expert.name" class='single-speaker gdlr-speaker-session-title h4'>All talks by {{expert.name}} from other editions</h3>
                                                <div v-for="(aTalk, index) in talksToBeDisplayedOnBottom" :key="index">
                                                    <div v-if="aTalk && aTalk.postPermalink">
                                                        <div v-for="(aTalkEdition, index) in aTalk.singleEditionLabels" :key="index">
                                                            <div v-if="aTalkEdition">
                                                                <div>
                                                                    <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible-de speaker-edition-label-display speaker-session-view-location-tag '>
                                                                        {{getGermanEditionName(aTalkEdition)}}
                                                                    </span>
                                                                    <span style='margin-right: 5px;' :style="{'background-color': getThisEditionColor(aTalkEdition,aTalk)}" class='language-dependent-block-invisible speaker-edition-label-display speaker-session-view-location-tag '>
                                                                        {{getEnglishEditionName(aTalkEdition)}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <a :href="'/'+aTalk.postPermalink">
                                                            <p style='display:inline;'>{{aTalk.title}}</p>
                                                        </a><br /><br />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'

export default {
    name: "ExpertDetail",
    props: {
        settingsPerm: Object
    },
    data() {
        return {
            expertSlug: this.settingsPerm.postSlug,
            conferenceBrandId: this.settingsPerm.conferenceBrandId,
            result: null,
            testResults: null,
            currentActiveLocation: null,
            loading: true,
            error: true,
            activeLocationEditionLabel: [],
            container: this.settingsPerm.container,
            newSessionIds: [],
            currentInstanceIds: [],
            expertTalksInstanceIds: [],
            seriesLanguages: [],
            showWPData: true,
            wpSiteLanguage: this.settingsPerm.wpSiteLanguage,
            activeLocations: this.settingsPerm.activeLocations,
            expert: {},
            maybLoadedEditionLabelTX: this.settingsPerm.maybLoadedEditionLabelTX,
            reactiveObject: {},
            talkToBeDisplayedOnTopInstanceIds: [],
            editionLabelTXDataForThisExpert: [],
            talksToBeDisplayedOnTop: [],
            BackendTalksToBeDisplayedOnTop: [],
            talksToBeDisplayedOnBottom: [],
            talksNotMatchingToSessions: [],
            locationsCurrentTalksBelongsTo: [],
            insideBeforeUpdate: false,
            expertSessionsComingFromBackend: null,
            breakEvenPoint: this.settingsPerm.breakEvenPoint,
            activeSessionLocations: this.settingsPerm.activeLocations,
            allTalksOfThisExpert: this.settingsPerm.allTalksOfTheSpeaker,
            widgetHtml: this.settingsPerm.widgetHtml,
            disturberHtml: this.settingsPerm.disturberHtml,
            cookie: window.jQuery.cookie("event_location"),
            theMaybeSetPLLCookieValue: window.jQuery.cookie("pll_language"),
            activeLocationsOfThisExpert: [],
            meta: null,
            languageToDisplay: null,
            currentmlcLocation: null,
        };
    },
    created() {
        if (this.theMaybeSetPLLCookieValue) {
            this.languageToDisplay = this.theMaybeSetPLLCookieValue;
        } else {
            this.languageToDisplay = this.wpSiteLanguage.slice(0, 2);
        }
        //maybe not needed
        if (this.allTalksOfThisExpert && this.allTalksOfThisExpert.length) {
            this.allTalksOfThisExpert == this.allTalksOfThisExpert;
        }

        //getting the active location based of cookie
        if (this.cookie && this.cookie != 'all' && this.cookie != undefined && this.activeSessionLocations && this.activeSessionLocations.length) {
            this.currentActiveLocation = this.activeSessionLocations.find(aLocation => {
                return aLocation.identifier == this.cookie;
            })
        }

        //getting editionLabels related to active location
        this.activeLocations.forEach(aLocation => {
            if (!this.activeLocationEditionLabel.includes(aLocation.editionlabel)) {
                this.activeLocationEditionLabel.push(aLocation.editionlabel);
            }
        });

        //get current Instances of this Brand
        if (this.settingsPerm && this.settingsPerm.postSlug) {
            const cache = new InMemoryCache();
            const apolloClient = new ApolloClient({
                cache,
                uri: window.walkuere_app_data.concord_url,
            })
            provideApolloClient(apolloClient)

            if (this.conferenceBrandId) {
                let variablesForInstance = {
                    brandId: this.conferenceBrandId,
                };
                const {
                    result
                } = useQuery(CONCORD_QUERIES.GET_CURRENT_INSTANCE_QUERY, variablesForInstance);
                watch(result, value => {
                    if (result && value && value.conferenceBrands && value.conferenceBrands.ConferenceBrands && value.conferenceBrands.ConferenceBrands.length) {
                        if (value.conferenceBrands.ConferenceBrands[0] && value.conferenceBrands.ConferenceBrands[0].conferenceSeriesItems && value.conferenceBrands.ConferenceBrands[0].conferenceSeriesItems.length) {
                            value.conferenceBrands.ConferenceBrands[0].conferenceSeriesItems.forEach(aSeriesItem => {
                                if (aSeriesItem && aSeriesItem.currentCourse && aSeriesItem.currentCourse.uniqueId) {
                                    if (aSeriesItem.currentCourse.language && !this.seriesLanguages.includes(aSeriesItem.currentCourse.language)) {
                                        this.seriesLanguages.push(aSeriesItem.currentCourse.language);
                                    }
                                    if (this.activeLocations && this.activeLocations.length) {
                                        this.activeLocations.forEach(aLocation => {
                                            if (aLocation.select_series[0] == aSeriesItem._id) {
                                                aLocation.instanceID = aSeriesItem.currentCourse.uniqueId
                                            }
                                        });
                                    }
                                    this.currentInstanceIds.push(aSeriesItem.currentCourse.uniqueId);
                                }
                            });
                            this.callExpertQuery();
                        } else {
                            this.callExpertQuery();
                        }
                    } else {
                        this.callExpertQuery();
                    }
                })
            }

        }
    },
    beforeUpdate() {
        if (window && window["moveDisturber"]) {
            window["moveDisturber"]();
        }
    },
    updated() {
        this.cookie = window.jQuery.cookie("event_location");
        if (this.cookie && (typeof this.cookie !== "undefined") && (this.cookie != "") && (this.cookie != "all")) {
            window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).addClass('mlc-location-dependent-block-visible');
            window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).removeClass('mlc-location-dependent-block-invisible');
        } else {
            // we do NOT have a location so we do somtehing with location dependend things
            window.jQuery('.mlc-location-independent-block-invisible').addClass('mlc-location-independent-block-visible');
            window.jQuery('.mlc-location-independent-block-invisible').removeClass('mlc-location-independent-block-invisible');
        }
        if (this.theMaybeSetPLLCookieValue && (typeof this.theMaybeSetPLLCookieValue !== "undefined") && (this.theMaybeSetPLLCookieValue != "") && (this.theMaybeSetPLLCookieValue == 'de')) {
            window.jQuery('.language-dependent-block-invisible-de').addClass('language-dependent-block-visible');
            window.jQuery('.language-dependent-block-invisible-de').removeClass('language-dependent-block-invisible-de');
        } else {
            window.jQuery('.language-dependent-block-invisible').addClass('language-dependent-block-visible');
            window.jQuery('.language-dependent-block-invisible').removeClass('language-dependent-block-invisible');
        }
        if (this.widgetHtml && this.widgetHtml && window["moveDisturber"]) {
            window["moveDisturber"]();
        }
    },
    methods: {
        aTalkEditionIsInActiveSessions(aTalkEdition, activeSessionLocations) {
            let editionNames = [];
            if (activeSessionLocations && activeSessionLocations.length) {
                activeSessionLocations.forEach(aSL => {
                    editionNames.push(aSL.toUpperCase());
                });
            }
            if (editionNames && editionNames.length && editionNames.includes(aTalkEdition.toUpperCase())) {
                return true;
            } else {
                return false;
            }
        },
        getThisEditionColor(aTalkEdition, aTalk) {
            let bgColor = '#fff'
            if (aTalk && aTalk.locationColors) {
                let entries = Object.entries(aTalk.locationColors)
                entries.map(([key, color]) => {
                    if (key.toLowerCase() == aTalkEdition.toLowerCase()) {
                        bgColor = color;
                    }

                });
            }

            return bgColor;
        },
        getGermanEditionName(aTalkEdition) {
            let deName = '';
            if (aTalkEdition && this.maybLoadedEditionLabelTX) {
                let entries = Object.entries(this.maybLoadedEditionLabelTX)
                entries.map(([key, value]) => {
                    if (key.toLowerCase() == aTalkEdition.toLowerCase()) {
                        deName = value.edition_label_de
                    }
                });

            }
            return deName;
        },
        getEnglishEditionName(aTalkEdition) {
            let enName = '';
            if (aTalkEdition && this.maybLoadedEditionLabelTX) {
                let entries = Object.entries(this.maybLoadedEditionLabelTX)
                entries.map(([key, value]) => {
                    if (key.toLowerCase() == aTalkEdition.toLowerCase()) {
                        enName = value.edition_label_en
                    }
                });

            }
            return enName;
        },
        filterTalkByLocation(talks, identifier) {
            let filteredTalks = false;
            filteredTalks = talks.filter(aTalk => {
                return aTalk.postPermalink && aTalk.locationIdentifier.includes(identifier)
            })
            return filteredTalks;
        },
        locationBelongsToaCurrentOne(edition) {
            let x = edition.filter(aEdition => {
                return aEdition.belongsTo;
            })
            if (x && x.length) {
                return x;
            }
            return false
        },
        //get and display Expert Data Start
        callExpertQuery() {
            this.loading = false;
            let variablesForQier = {
                slug: this.expertSlug,
                conferenceBrandId: this.conferenceBrandId
            };
            const {
                result
            } = useQuery(CONCORD_QUERIES.EXPERT_BY_SLUG_QUERY, variablesForQier);
            watch(result, value => {
                if (result && value) {
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.forename) {
                        this.expert['forename'] = value.vueExpert.Expert.forename;
                    }
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.surname) {
                        this.expert['surname'] = value.vueExpert.Expert.surname;
                    }
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.company) {
                        this.expert['company'] = value.vueExpert.Expert.company;
                    }
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.bioEn && this.languageToDisplay == 'en') {
                        this.expert['bio'] = value.vueExpert.Expert.bioEn;
                    } else if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.bioDe) {
                        this.expert['bio'] = value.vueExpert.Expert.bioDe;
                    } else {
                        this.expert['bio'] = this.settingsPerm.postContent;
                    }
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.facebook) {
                        this.expert['facebook'] = value.vueExpert.Expert.facebook;
                    } else {
                        this.expert['facebook'] = this.settingsPerm.facebook;
                    }
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.twitter) {
                        this.expert['twitter'] = value.vueExpert.Expert.twitter;
                    } else {
                        this.expert['twitter'] = this.settingsPerm.twitter;
                    }
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.linkedIn) {
                        this.expert['linkedIn'] = value.vueExpert.Expert.linkedIn;
                    } else {
                        this.expert['linkedIn'] = this.settingsPerm.linkedIn;
                    }
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.blog) {
                        this.expert['blog'] = value.vueExpert.Expert.blog;
                    } else {
                        this.expert['blog'] = this.settingsPerm.blog;
                    }
                    if (value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert.avatarSquareSmall && value.vueExpert.Expert.avatarSquareSmall.xxx) {
                        this.expert['image'] = value.vueExpert.Expert.avatarSquareSmall.xxx;
                    } else if (this.settingsPerm.expertImage) {
                        this.expert['wpImage'] = this.settingsPerm.expertImage;
                    }
                    if (!value.vueExpert.Expert && this.settingsPerm.postTitle) {
                        this.expert['name'] = this.settingsPerm.postTitle;
                    }
                    if (this.expert && this.expert.surname && this.expert.forename && this.expert.bio) {
                        let schemaOrg = document.getElementsByClassName('yoast-schema-graph');
                        if (schemaOrg && schemaOrg.length && schemaOrg[0].innerHTML) {
                            let newDataSrting = schemaOrg[0].innerHTML.replaceAll('@', 'AAA20')
                            let schemaInnerHtml = JSON.parse(newDataSrting);

                            if (schemaInnerHtml && schemaInnerHtml.AAA20graph && schemaInnerHtml.AAA20graph.length) {
                                schemaInnerHtml.AAA20graph[0].description = this.expert.bio;
                            }
                            schemaInnerHtml = JSON.stringify(schemaInnerHtml);
                            let newDataAsString = schemaInnerHtml.replaceAll('AAA20', '@')
                            schemaOrg[0].innerHTML = newDataAsString;
                        }
                        let meta = {
                            "title": this.expert.forename + " " + this.expert.surname,
                            "description": this.expert.bio,
                            "robots": "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
                            "canonical": window.location.href,
                            "og:locale": "en_GB",
                            "og:type": "article",
                            "og:title": this.expert.forename + " " + this.expert.surname,
                            "og:description": this.expert.bio,
                            "og:url": window.location.href,
                            "og:site_name": this.settingsPerm.siteInfo,
                        }
                        let metaArry = Object.keys(meta);
                        metaArry.forEach(key => {
                            var metaTag = document.createElement('meta');
                            metaTag.setAttribute('name', key);
                            metaTag.setAttribute('content', meta[key]);
                            document.getElementsByTagName('head')[0].appendChild(metaTag)
                        });
                    }
                    //our sessions magic will start here

                    if (value.vueExpert.Expert && value.vueExpert.Expert.sessions && value.vueExpert.Expert.sessions.length) {
                        let CurrentTalkslocationss;
                        this.expertSessionsComingFromBackend = value.vueExpert.Expert.sessions;
                        let counter = 0;
                        value.vueExpert.Expert.sessions.forEach(aSession => {
                            counter++;
                            if (aSession && aSession.conferenceIds && aSession.conferenceIds.length) {
                                aSession.conferenceIds.forEach(conferenceInstanceId => {
                                    /* eslint-disable */
                                    for (const [key, value] of Object.entries(this.maybLoadedEditionLabelTX)) {
                                        if (value && value.edition_identifier && value.edition_identifier.trim() == conferenceInstanceId.trim()) {
                                            if (this.editionLabelTXDataForThisExpert) {
                                                this.activeLocations.forEach(aActiveLocation => {
                                                    if (typeof aActiveLocation.editionlabelaliases === 'string' && aActiveLocation.editionlabelaliases.split(',').includes(value.edition_label)) {
                                                        value.belongsTo = aActiveLocation.city;
                                                    }
                                                })
                                                let doFindTheMatching = this.editionLabelTXDataForThisExpert.filter(atxData => {
                                                    return atxData.edition_identifier == value.edition_identifier;
                                                })
                                                if (doFindTheMatching.length == 0) {
                                                    this.editionLabelTXDataForThisExpert.push(value)
                                                }
                                            }
                                        }
                                    }
                                    /* eslint-enable */
                                    if (!this.expertTalksInstanceIds.includes(conferenceInstanceId)) {
                                        this.expertTalksInstanceIds.push(conferenceInstanceId);
                                    }
                                })
                            }
                            let newSession = {};
                            if (aSession && aSession.updatedAt) {
                                if (window.moment(aSession.updatedAt, 'DD/MM/YYYY HH:mm:ss').isAfter(window.moment(this.breakEvenPoint, 'DD/MM/YYYY'))) {
                                    newSession['locationColors'] = {}
                                    newSession['locationAliases'] = {}
                                    this.activeLocations.forEach(aActiveLocation => {
                                        if (aActiveLocation && aActiveLocation.editionlabel) {
                                            newSession.locationColors[aActiveLocation.editionlabel] = aActiveLocation.location_color;
                                        }
                                        if (aActiveLocation && aActiveLocation.editionlabelaliases) {
                                            newSession.locationAliases[aActiveLocation.editionlabel] = aActiveLocation.editionlabelaliases;
                                        }
                                        if (aSession.conferenceIds && aSession.conferenceIds.length) {
                                            aSession.conferenceIds.forEach(sessionInstanceID => {
                                                if (!newSession.title && aSession.name) {
                                                    newSession['title'] = aSession.name;
                                                }
                                                if (!newSession.id && aSession._id) {
                                                    newSession['id'] = aSession._id;
                                                }
                                                if (!newSession.conferenceIds && aSession.conferenceIds && aSession.conferenceIds.length) {
                                                    newSession['conferenceIds'] = aSession.conferenceIds;
                                                }
                                                if (!newSession.postPermalink && aSession.slugNames && aSession.slugNames && aSession.slugNames[0] && aSession.primaryTrack && aSession.primaryTrack.slug) {
                                                    newSession['postPermalink'] = aSession.primaryTrack.slug + '/' + aSession.slugNames[0];
                                                }
                                                if (aActiveLocation.instanceID && aActiveLocation.instanceID != undefined && sessionInstanceID === aActiveLocation.instanceID) {
                                                    if (this.activeLocationsOfThisExpert && this.activeLocationsOfThisExpert.length) {
                                                        let doWeFindTheduplicate = this.activeLocationsOfThisExpert.filter(aActiveLocationOfExpert => {
                                                            return aActiveLocationOfExpert.instanceID == aActiveLocation.instanceID;
                                                        })
                                                        if (doWeFindTheduplicate && doWeFindTheduplicate.length == 0) {
                                                            this.activeLocationsOfThisExpert.push(aActiveLocation);
                                                        }
                                                    } else {
                                                        this.activeLocationsOfThisExpert.push(aActiveLocation);
                                                    }

                                                    if (!this.newSessionIds.includes(aSession._id)) {
                                                        // this.newSessionIds.push(aSession._id);
                                                    }
                                                    if (!newSession.backendData) {
                                                        newSession['backendData'] = true;
                                                    }
                                                    if (!newSession.belongsToActiveLocation) {
                                                        newSession['belongsToActiveLocation'] = true;
                                                    }
                                                    newSession['sortNumber'] = -1;
                                                    if (!newSession.singleEditionLabels && aActiveLocation.editionlabel) {
                                                        newSession['singleEditionLabels'] = [aActiveLocation.editionlabel];
                                                        newSession['sortNumber'] = parseInt(aActiveLocation.editionlabel.slice(-2));
                                                    } else if (newSession.singleEditionLabels) {
                                                        newSession.singleEditionLabels.push(aActiveLocation.editionlabel);
                                                        
                                                    }
                                                    if (!newSession.locationIdentifier && aActiveLocation.identifier) {
                                                        newSession['locationIdentifier'] = [aActiveLocation.identifier];
                                                    } else if (newSession.locationIdentifier) {
                                                        newSession.locationIdentifier.push(aActiveLocation.identifier);
                                                    }
                                                    if (aSession.slugNames && aSession.slugNames[0]) {
                                                        // console.log("aSession", aSession);
                                                        if (aSession.conferenceIds && aSession.conferenceIds.length) {
                                                            this.locationsOfCurrentTalks =
                                                                aSession.conferenceIds.forEach(conferenceID => {

                                                                    if (!this.talkToBeDisplayedOnTopInstanceIds.includes(conferenceID)) {
                                                                        this.talkToBeDisplayedOnTopInstanceIds.push(conferenceID);
                                                                    }
                                                                });
                                                            // console.log("this.talkToBeDisplayedOnTopInstanceIds", this.talkToBeDisplayedOnTopInstanceIds);
                                                            if (this.talkToBeDisplayedOnTopInstanceIds && this.talkToBeDisplayedOnTopInstanceIds.length) {
                                                                CurrentTalkslocationss = [];
                                                                this.activeLocations.forEach(alocation => {
                                                                    if (this.talkToBeDisplayedOnTopInstanceIds.includes(alocation.instanceID)) {
                                                                        let doWeFindDuplicate = CurrentTalkslocationss.find(actl => {
                                                                            return actl.identifier == alocation.identifier;
                                                                        })
                                                                        if (!doWeFindDuplicate) {
                                                                            CurrentTalkslocationss.push(alocation);
                                                                        }
                                                                    }

                                                                })
                                                                // console.log("this.activeLocationsthis.activeLocationsthis.activeLocations",this.activeLocations);
                                                                // console.log("locationsCurrentTalksBelongsTo",this.locationsCurrentTalksBelongsTo);
                                                            }
                                                        }

                                                        this.talksToBeDisplayedOnTop.push(newSession);
                                                    }
                                                    let weAlreadyStoredThisTalk = this.talksNotMatchingToSessions.filter(aStoredSession => {
                                                        return aStoredSession.id == newSession.id;
                                                    })
                                                    //if cookie get identifier and filter talks
                                                    if (this.cookie && this.cookie != 'all') {
                                                        if (!newSession.locationIdentifier.includes(this.cookie) && weAlreadyStoredThisTalk.length == 0) {
                                                            this.talksNotMatchingToSessions.push(newSession);
                                                        }
                                                    }
                                                } else {
                                                    let weAlreadyStoredThisTalk = this.talksNotMatchingToSessions.filter(aStoredSession => {
                                                        return aStoredSession.id == newSession.id;
                                                    })
                                                    if (!this.talkBelongsToActiveLocation(aSession) &&  weAlreadyStoredThisTalk.length == 0) {
                                                        newSession['singleEditionLabels'] = this.getEditionLabelsOfwalkurieArchiveSessions(newSession);
                                                        if (this.getEditionLabelsOfwalkurieArchiveSessions(newSession) && this.getEditionLabelsOfwalkurieArchiveSessions(newSession).length && 
                                                        this.getEditionLabelsOfwalkurieArchiveSessions(newSession)[0] && this.getEditionLabelsOfwalkurieArchiveSessions(newSession)[0].length ) {
                                                            newSession['sortNumber'] = parseInt(this.getEditionLabelsOfwalkurieArchiveSessions(newSession)[0].slice(-2));
                                                        } else {
                                                           newSession['sortNumber'] = -1; 
                                                        }
                                                        
                                                        this.talksNotMatchingToSessions.push(newSession);
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                            if (counter == value.vueExpert.Expert.sessions.length) {
                                this.processWpDataNow();
                            }
                        });
                        this.loading = false;
                        if (CurrentTalkslocationss && CurrentTalkslocationss.length) {
                            CurrentTalkslocationss.forEach(alocation => {
                                this.locationsCurrentTalksBelongsTo.push(alocation);
                            });
                        }
                    } else {
                        this.processWpDataNow();
                    }

                } else {
                    this.processWpDataNow();
                }
                this.loading = false;
            })
        },
        getEditionLabelsOfwalkurieArchiveSessions(session) {
            if (session && this.maybLoadedEditionLabelTX) {
                let entries = Object.entries(this.maybLoadedEditionLabelTX);
                let editionLabels = [];
                entries.map(([key, value]) => {
                    if (session.conferenceIds && session.conferenceIds.length) {
                        session.conferenceIds.forEach(sessionInstanceID => {
                            if (sessionInstanceID && sessionInstanceID == value.edition_identifier) {
                                editionLabels.push(key);
                            }
                        })
                    }
                });
                return editionLabels;

            }
        },
        talkBelongsToActiveLocation(aSession) {
            let belongsToActiveLocation = false;
            if (aSession && aSession.conferenceIds && aSession.conferenceIds.length) {
                aSession.conferenceIds.forEach(sessionInstanceID => {
                    if (this.activeLocations && this.activeLocations.length) {
                        this.activeLocations.forEach(aActiveLocation => {
                            if (aActiveLocation.instanceID && aActiveLocation.instanceID != undefined && sessionInstanceID === aActiveLocation.instanceID) {
                                belongsToActiveLocation = true;
                            }
                        });
                    }
                });
            }
            return belongsToActiveLocation;
        },
        //get and display Expert Data Ends
        processWpDataNow() {
            if (!this.insideBeforeUpdate) {
                let weHaveOnlyNewSessions = true;
                let allNewSessionsAlreadyProcessed = true;
                this.loading = false;
                this.insideBeforeUpdate = true;
                if (this.expertSessionsComingFromBackend && this.expertSessionsComingFromBackend.length && this.newSessionIds && this.newSessionIds.length) {
                    this.expertSessionsComingFromBackend.forEach(aSession => {
                        let newSessionforBottom = {};
                        if (this.newSessionIds.length) {
                            allNewSessionsAlreadyProcessed = false;
                            for (const [key, value] of Object.entries(this.maybLoadedEditionLabelTX)) {
                                if (aSession.conferenceIds && aSession.conferenceIds.length) {
                                    aSession.conferenceIds.forEach(sessionInstanceID => {
                                        if (sessionInstanceID && sessionInstanceID == value.edition_identifier) {
                                            if (!newSessionforBottom.backendData) {
                                                newSessionforBottom['backendData'] = true;
                                            }
                                            if (!newSessionforBottom.belongsToActiveLocation) {
                                                newSessionforBottom['belongsToActiveLocation'] = true;
                                            }
                                            if (!newSessionforBottom.title && aSession.name) {
                                                newSessionforBottom['title'] = aSession.name;
                                            }
                                            if (!newSessionforBottom.id && aSession._id) {
                                                newSessionforBottom['id'] = aSession._id;
                                            }
                                            if (!newSessionforBottom.postPermalink && aSession.slugNames && aSession.slugNames && aSession.primaryTrack && aSession.primaryTrack.slug && aSession.slugNames[0]) {
                                                newSessionforBottom['postPermalink'] = aSession.primaryTrack.slug + '/' + aSession.slugNames[0];
                                            }
                                            if (!newSessionforBottom.singleEditionLabels && key) {
                                                newSessionforBottom['singleEditionLabels'] = [key];
                                            } else if (newSessionforBottom.singleEditionLabels) {
                                                newSessionforBottom.singleEditionLabels.push(key);
                                            }
                                        }
                                    })
                                }
                            }
                            if (aSession.slugNames && aSession.slugNames[0]) {
                                this.talksToBeDisplayedOnBottom.push(newSessionforBottom);
                            }
                            this.loading = false;
                        }
                    })
                }
                if (this.allTalksOfThisExpert && this.allTalksOfThisExpert.length) {
                    weHaveOnlyNewSessions = false;
                    let editionLabelsInLowerCase = [];
                    this.activeLocationEditionLabel.forEach(aEdition => {
                        editionLabelsInLowerCase.push(aEdition.toLowerCase());
                    });
                    this.allTalksOfThisExpert = this.allTalksOfThisExpert.sort(function (a, b) {
                        return b.publishedYear - a.publishedYear;
                    });
                    this.allTalksOfThisExpert.forEach(atalk => {
                        if (atalk && atalk.singleEditionLabels) {
                            let talkMatchesToOneOfTheCurrentLocation = atalk.singleEditionLabels.find(aEditionLabel => {
                                return editionLabelsInLowerCase.includes(aEditionLabel.toLowerCase());
                            })
                            if (talkMatchesToOneOfTheCurrentLocation) {
                                this.activeLocations.forEach(aActiveLocation => {
                                    if (talkMatchesToOneOfTheCurrentLocation.toLowerCase() == aActiveLocation.editionlabel.toLowerCase()) {
                                        if (!atalk.locationIdentifier && aActiveLocation.identifier) {
                                            atalk['locationIdentifier'] = [aActiveLocation.identifier];
                                        } else if (atalk.locationIdentifier) {
                                            atalk.locationIdentifier.push(aActiveLocation.identifier);
                                        }
                                    }
                                })
                                this.BackendTalksToBeDisplayedOnTop.push(atalk);
                            } else {
                                this.talksToBeDisplayedOnBottom.push(atalk);
                            }
                        }

                    });
                    let thiss = this;
                    if ((thiss.cookie && thiss.cookie == 'all') || thiss.cookie == undefined || !thiss.cookie) {
                        if (this.BackendTalksToBeDisplayedOnTop && this.BackendTalksToBeDisplayedOnTop.length) {
                            let currentBackendTalkEdition = thiss.activeLocations.find(aLocation => {
                                return this.BackendTalksToBeDisplayedOnTop[0].locationIdentifier.includes(aLocation.identifier);
                            })
                            if (currentBackendTalkEdition) {
                                this.locationsCurrentTalksBelongsTo.push(currentBackendTalkEdition);
                            }

                        }
                    }
                    let sliced = this.talksToBeDisplayedOnBottom.slice(0, 18);
                    if (this.talksNotMatchingToSessions && this.talksNotMatchingToSessions.length) {
                        this.talksToBeDisplayedOnBottom = this.talksNotMatchingToSessions.concat(sliced);
                    } else {
                        this.talksToBeDisplayedOnBottom = sliced;
                    }
                    this.loading = false;
                }
                if (weHaveOnlyNewSessions && allNewSessionsAlreadyProcessed) {
                    this.loading = false;
                    this.talksNotMatchingToSessions = this.talksNotMatchingToSessions.sort(function (a, b) {
                        return b.sortNumber - a.sortNumber;
                    });
                    this.talksToBeDisplayedOnBottom = this.talksNotMatchingToSessions;

                }
            }
        }
    }
}
</script>

<style lang="css" scoped>
.to-the-current-program-page-block {
    padding: 15px 8px 0 20px;
    vertical-align: middle;
    font-weight: 600;
    margin-bottom: 25px;
    padding-bottom: 15px;
    text-align: left;

}

.to-the-current-program-page-block .go-to-program-page.language-dependent-block-visible {
    display: inline-block !important;
}
.expert-image-eapper{
    width:22%;
    min-width: 265px;
}
.expert-info-wrapper__bio .expert__title{
    font-size: 60px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.ex__new__wrapper{
    gap: 50px;
    border-radius: 25px;
    background: #F0F0F0;
    align-items: center;
}
.expert-info-wrapper__bio{
    width: 70%;
}
.expert-info-wrapper__bio h2{
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: normal; 
}
.sands-image-colored-overlay-hover img{
    border-radius: 50%;
    height: 275px;
    width: 275px;
    object-fit: cover;
}
.expert-image-eapper .gdlr-speaker-thumbnail{
}

.sands-image-colored-overlay-hover::before{
    content: "";
    height: 100% !important;
    background: #6A6A6A;
    position: absolute;
    width: 1px;
    right: -20px;
}
.bottom-talks, .top-sessions__wrapper_with_location{
    border-radius: 25px;
    background: #F0F0F0;
}


@media only screen and (max-width: 768px) {
    .ex__new__wrapper{
        display: flex;
        flex-direction: column;
    }
    .sands-image-colored-overlay-hover::before{
        display: none;
    }
    .expert-info-wrapper__bio{
       border-top: 1px solid grey; 
    }
    .expert-info-wrapper__bio{
        width: 100%;
    }
    .expert-image-eapper{
            width: 270px;
    }
    .expert-info-wrapper__bio .expert__title {
        font-size: 44px;

    }
    .sands-image-colored-overlay-hover img{
    border-radius: 50%;
    height: 275px;
    width: 275px;
    object-fit: cover;
}
}
.single-speaker .gdlr-speaker-info-wrapper{
    width: 24%;
}
@media only screen and (max-width: 767.9px) {
    .single-speaker .gdlr-speaker-info-wrapper{
        margin-right: 0px;
        width: 100%;
    }
}
</style>
